export default time => new Promise(resolve => setTimeout(resolve, time));




// WEBPACK FOOTER //
// ./app/scripts/utils/sleep-promise.js